import parseString from 'html-react-parser';

const parseStringToHTML = (stringVariable: string): JSX.Element | JSX.Element[] => {
    return parseString(`${stringVariable}`);
};

export default parseStringToHTML;
